
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M29.68 6.976H9.778L10.1 24.47l17.123 17.334h10.75V15.268h-8.292z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M14.754 20.346V2h19.073l9.122 9.122v25.707H27.834"}}),_c('path',{attrs:{"stroke":"#234652","d":"M31.722 2.569v8.988h8.988"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M6.43 45.263H26L6.43 25.694z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M10.29 25.18v15.9h15.899M24.777 26.306 10.532 40.803M30.362 18.632h-4.5v4.5h4.275v-2.25H27.66"}})])
          )
        }
      }
    